module.exports = __webpack_public_path__ + "img/fix_close_btn.d322ea74.svg";